import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import VerifyTwoFactor from "components/User/2FA/Login/VerifyTwoFactor";
import SelectTwoFactor from "components/User/2FA/Login/SelectTwoFactor";

import { userLogout } from "actions/user";

const TwoFactorAuthLogin = (props) => {
  // response from auth server for 2fa setup
  const [multiFactorVerifyStartResponse, setMultiFactorVerifyStartResponse] = useState({ data: null, isFetching: false });
  // Method override to allow resending a code
  const [methodOverride, setMethodOverride] = useState(null);
  // Allows auto-submit for verification if only one method is available
  const [verifyInitiated, setVerifyInitiated] = useState(false);

  const { twoFactor: { authResult }, history, userLogout } = props;

  if (!authResult.loginResult) {
    userLogout();
    return null;
  }

  const { loginResult: { authenticationToken, multiFactorMethodsAvailable, multiFactorRememberThisClientTokenAllowed }, username } = authResult;

  let clearTwoFactorResponse = () => {
    setMethodOverride(null);
    setMultiFactorVerifyStartResponse({ data: null, isFetching: false });
  };

  let getAvailableMethods = () => {
    if (!methodOverride) {
      return multiFactorMethodsAvailable;
    } else {
      return [methodOverride];
    }
  };

  let resendCode = (method) => {
    setVerifyInitiated(false);
    setMethodOverride(method);
    setMultiFactorVerifyStartResponse({ data: null, isFetching: false });
  };

  return (
    <div className="two-factor">
      {!multiFactorVerifyStartResponse.data &&
        <SelectTwoFactor
          username={username}
          userLogout={userLogout}
          multiFactorMethods={getAvailableMethods()}
          authenticationToken={authenticationToken}
          multiFactorVerifyStartResponse={multiFactorVerifyStartResponse}
          setMultiFactorVerifyStartResponse={setMultiFactorVerifyStartResponse}
          verifyInitiated={verifyInitiated}
          setVerifyInitiated={setVerifyInitiated}
        />
      }
      {multiFactorVerifyStartResponse.data &&
        <VerifyTwoFactor
          history={history}
          multiFactorInitiatedResponse={multiFactorVerifyStartResponse}
          clearTwoFactorResponse={clearTwoFactorResponse}
          resendCode={resendCode}
          multiFactorRememberThisClientTokenAllowed={multiFactorRememberThisClientTokenAllowed}
        />
      }
    </div>
  );
};

TwoFactorAuthLogin.propTypes = {
  twoFactor: PropTypes.object,
  authResult: PropTypes.object,
  history: PropTypes.object,
  userLogout: PropTypes.func,
};

const mdtp = dispatch => ({
  userLogout() {
    dispatch(userLogout());
  }
});

const mstp = state => ({
  twoFactor: state.twoFactor
});

export default connect(mstp, mdtp)(TwoFactorAuthLogin);